<template>
  <div style="margin-bottom:25px;">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="data" label="序号" align="center" width="84"></el-table-column>
      <el-table-column prop="" label="债券代码" width="150" align="center">
        <template slot-scope="scope">
            <a style="color:#4372ba;cursor: pointer;">
              {{scope.row.data2}}
            </a>
        </template>
      </el-table-column>
      <el-table-column prop="" label="债券名称" width="150" align="center">
        <template slot-scope="scope">
            <a style="color:#4372ba;cursor: pointer;">
              {{scope.row.data3}}
            </a>
        </template>
      </el-table-column>
      <el-table-column prop="" label="最新价" min-width="150" align="center">
        <template slot-scope="scope">
            <div :class="{'color_red':scope.row.data5 > 0,'color_green':scope.row.data5 < 0}" style="text-align:center">
              {{scope.row.data4}}
            </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="涨跌幅" width="150" align="center">
        <template slot-scope="scope">
            <div :class="{'color_red':scope.row.data5 > 0,'color_green':scope.row.data5 < 0}" style="text-align:center">
              {{scope.row.data5}}%
            </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="相关资讯" min-width="150" align="center">
        <template slot-scope="scope">
            <a style="color:#4372ba;cursor: pointer;">
              {{scope.row.data6}}
            </a>
        </template>
      </el-table-column>
      <el-table-column prop="data7" label="占净值比例" width="150" align="center"></el-table-column>
      <el-table-column prop="data8" label="持股数(万股)" width="150" align="center"></el-table-column>
      <el-table-column prop="data9" label="持仓市值(万元)" width="150" align="center"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          data: "1",
          data2: "600519",
          data3: "贵州茅台",
          data4: "1790.40",
          data5: "-0.48",
          data6: "相关资讯",
          data7: "9.56%",
          data8: "0.22",
          data9: "451.00",
        },
        {
          data: "2",
          data2: "600519",
          data3: "ST国医",
          data4: "8.61",
          data5: "-0.48",
          data6: "相关资讯",
          data7: "9.56%",
          data8: "0.22",
          data9: "451.00",
        },
        {
          data: "3",
          data2: "600519",
          data3: "通策医疗",
          data4: "161.29",
          data5: "0.51",
          data6: "相关资讯",
          data7: "9.56%",
          data8: "0.22",
          data9: "451.00",
        },
        {
          data: "4",
          data2: "600519",
          data3: "亿纬锂能",
          data4: "59.50",
          data5: "0.17",
          data6: "相关资讯",
          data7: "9.56%",
          data8: "0.22",
          data9: "451.00",
        },
      ],
    };
  },
};
</script>

<style scoped>
.el-table /deep/ th {
  background-color: #f8f9fd !important;
  text-align: center;
  height: 56px;
}
.el-table /deep/ td {
  height: 56px;
}
.bg1{
    width: 44px;
	height: 8px;
    background-color: rgba(252,173,42,1);
    margin-left: 3px;
    margin-top: 4px;
}
.bg2{
    background-color: rgba(252,173,42,.12);
}
.border_radius_left{
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.border_radius_right{
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.box{
    display: flex;
    justify-content: center;
}
.bg_box{
    display: flex;
}
.text_box{
    margin-left: 6px;
    font-size: 16px;
	line-height: 16px;
	color: #fcad2a;
}
.color_red{
  color: #fd4c4c;
}
.color_green{
  color: #41b357;
  
}
</style>